
//  [대상 선수]
//
//  1. 카드 종류 - 골든 글러브, 시그니쳐 등 - CardType
//  2. 선택 팀 - 두산, 삼성 등 - Team
//  3. 선택 올스타 팀 - 드림, 나눔 등 - AllStarTeam
//  3. 대표 포지션 - 타자, 투수 - MainPosition
//  4. 선택 연도 타자/투수 - 16년도 타자, 20년도 투수 등 - YearMainPosition
//  5. O성 선수 - 3성, 4성, 5성 - NumberOfStar
//  6. 세부 포지션 - 마무리 + 불펜 / 선발 투수 등 - Position
//  7. OVR 이상 타자/투수 - OVR 65 이상 투수 등 - OverMainPosition
//  8. 특정 타선 선수 - 6~9번 타자 선수 - BatterLineup
//  9. 선택 팀 특정 카드 - 두산 시그니쳐 등 - TeamCardType
//  10. 선택 팀 대표 포지션 - 두산 타자 등  - TeamMainPosition

import { batterKeys, pitcherKeys, positionKeys } from "./publicKeys"


//  [향상 능력치]
//  
//  1. 모든 능력치/특정 능력치 - States 
//  2. 포지션 별 다른 능력치 : 타자 : 인내 +1 / 투수 : 제구 +1 - StatesByMainPosition

const baseStates = { s1: 0, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0}
const baseStatesWithOne = { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1}
const baseStatesWithTwo = { s1: 2, s2: 2, s3: 2, s4: 2, s5: 2, s6: 2}

export const setDeckEffects = [
    {
        point: 30, 
        left: {
            target: {
                type: 'Team',
                label: '선택 팀 선수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        },
        right: {
            target: {
                type: 'CardType',
                cardTypes: ['임팩트', '국가대표', '시그니쳐', '골든글러브'],
                label: '임팩트&국가대표&<br>시그니쳐&골든글러브 선수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        }
    },
    {
        point: 40, 
        left: {
            target: {
                type: 'Position',
                positions: batterKeys,
                label: '타자'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        },
        right: {
            target: {
                type: 'Position',
                positions: pitcherKeys,
                label: '투수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        }
    },
    {
        point: 50, 
        left: {
            target: {
                type: 'CardType',
                cardTypes: ['시즌', '라이브', '올스타'],
                label: '시즌&라이브&올스타 선수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        },
        right: {
            target: {
                type: 'CardType',
                cardTypes: ['임팩트', '국가대표', '시그니쳐', '골든글러브'],
                label: '임팩트&국가대표&<br>시그니쳐&골든글러브 선수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        }
    },
    {
        point: 55, 
        left: {
            target: {
                type: 'YearPosition',
                positions: batterKeys,
                label: '선택 연도 타자'
            },
            effect: {
                type: 'States',
                states: {...baseStates, s5: 2, s6: 2},
                label: '주루, 수비 +2'
            }
        },
        right: {
            target: {
                type: 'YearPosition',
                positions: pitcherKeys,
                label: '선택 연도 투수'
            },
            effect: {
                type: 'States',
                states: {...baseStates, s2: 2, s5: 2},
                label: '변화, 지구력 +2'
            }
        }
    },
    {
        point: 60, 
        left: {
            target: {
                type: 'Position',
                positions: batterKeys,
                label: '타자'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        },
        right: {
            target: {
                type: 'Position',
                positions: pitcherKeys,
                label: '투수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        }
    },
    {
        point: 65, 
        left: {
            target: {
                type: 'NumberOfStar',
                numberOfStar: 3,
                label: '3성 선수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithTwo,
                label: '모든 능력치 +2'
            }
        },
        right: {
            target: {
                type: 'NumberOfStar',
                numberOfStar: 4,
                label: '4성 선수'
            },
            effect: {
                type: 'StatesByPosition',
                statesForBatter: {...baseStates, s2: 2, s4: 2},
                statesForPitcher: {...baseStates, s1: 2, s4: 2},
                label: '타자 : 정확, 인내 +2<br>투수 : 구속, 제구 +2',

            }
        }
    },
    {
        point: 70, 
        left: {
            target: {
                type: 'Position',
                positions: ['SP1', 'SP2', 'SP3', 'SP4', 'SP5'],
                label: '선발 투수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        },
        right: {
            target: {
                type: 'Position',
                positions: ['RP1', 'RP2', 'RP3', 'RP4', 'RP5', 'RP6', 'CP'],
                label: '불펜 투수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithTwo,
                label: '모든 능력치 +2'
            }
        }
    },
    {
        point: 75, 
        left: {
            target: {
                type: 'YearPosition',
                positions: batterKeys,
                label: '선택 연도 타자'
            },
            effect: {
                type: 'States',
                states: {...baseStates, s1: 3, s2: 3},
                label: '파워, 정확 +3'
            }
        },
        right: {
            target: {
                type: 'YearPosition',
                positions: pitcherKeys,
                label: '선택 연도 투수'
            },
            effect: {
                type: 'States',
                states: {...baseStates, s3: 3, s4: 3},
                label: '구위, 제구 +3'
            }
        }
    },
    {
        point: 80, 
        left: {
            target: {
                type: 'OvrPosition',
                positions: batterKeys,
                ovr: 65,
                label: 'OVR 65 이상 타자'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        },
        right: {
            target: {
                type: 'OvrPosition',
                positions: pitcherKeys,
                ovr: 65,
                label: 'OVR 65 이상 투수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        }
    },
    {
        point: 85, 
        left: {
            target: {
                type: 'NumberOfStar',
                numberOfStar: 4,
                label: '4성 선수'
            },
            effect: {
                type: 'StatesByPosition',
                statesForBatter: {...baseStates, s1: 2, s2: 2, s3: 2},
                statesForPitcher: {...baseStates, s2: 2, s3: 2, s4: 2},
                label: '타자 : 파워, 정확, 선구 +2 <br>투수 : 구위, 제구, 변화 +2',
            }
        },
        right: {
            target: {
                type: 'NumberOfStar',
                numberOfStar: 5,
                label: '5성 선수'
            },
            effect: {
                type: 'StatesByPosition',
                statesForBatter: {...baseStates, s1: 1},
                statesForPitcher: {...baseStates, s3: 1},
                label: '타자 : 파워 +1<br>투수 : 구위 +1',

            }
        }
    },
    {
        point: 90, 
        left: {
            target: {
                type: 'Team',
                label: '선택 팀 선수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithTwo,
                label: '모든 능력치 +2'
            }
        },
        right: {
            target: {
                type: 'CardType',
                cardTypes: ['임팩트', '국가대표', '시그니쳐', '골든글러브'],
                label: '임팩트&국가대표&<br>시그니쳐&골든글러브 선수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithTwo,
                label: '모든 능력치 +2'
            }
        }
    },
    {
        point: 95, 
        left: {
            target: {
                type: 'Position',
                positions: ['1B', '2B', 'SS', '3B', 'C'],
                label: '내야수 + 포수'
            },
            effect: {
                type: 'States',
                states: {...baseStates, s4: 2, s6: 2},
                label: '인내, 수비 +2'
            }
        },
        right: {
            target: {
                type: 'Position',
                positions: ['LF', 'CF', 'RF', 'DH'],
                label: '외야수 + 지명타자'
            },
            effect: {
                type: 'States',
                states: {...baseStates, s3: 2, s5: 2},
                label: '선구, 주루 +2'
            }
        }
    },
    {
        point: 100, 
        left: {
            target: {
                type: 'Position',
                positions: batterKeys,
                label: '타자'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        },
        right: {
            target: {
                type: 'Position',
                positions: pitcherKeys,
                label: '투수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        }
    },
    {
        point: 105, 
        left: {
            target: {
                type: 'NumberOfStar',
                numberOfStar: 3,
                label: '3성 선수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithTwo,
                label: '모든 능력치 +2'
            }
        },
        right: {
            target: {
                type: 'NumberOfStar',
                numberOfStar: 4,
                label: '4성 선수'
            },
            effect: {
                type: 'StatesByPosition',
                statesForBatter: {...baseStates, s1: 2, s2: 2},
                statesForPitcher: {...baseStates, s2: 2, s3: 2},
                label: '타자 : 파워, 선구 +2<br>투수 : 구위, 변화 +2',

            }
        }
    },
    {
        point: 110, 
        left: {
            target: {
                type: 'AllStarTeam',
                teams: ['두산', '롯데', '삼성', 'SSG', 'KT'],
                label: '두산, 롯데, 삼성,<br>SSG, KT 선수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        },
        right: {
            target: {
                type: 'AllStarTeam',
                teams: ['KIA', '한화', 'LG', 'NC', '키움'],
                label: 'KIA, 한화, LG,<br>NC, 키움 선수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        }
    },
    {
        point: 115, 
        left: {
            target: {
                type: 'BatterLineup',
                positions: ['6번', '7번', '8번', '9번'],
                label: '하위 타선(6~9번)'
            },
            effect: {
                type: 'States',
                states: {...baseStates, s2: 2, s5: 2, s6: 2},
                label: '정확, 주루, 수비 +2'
            }
        },
        right: {
            target: {
                type: 'Position',
                positions: ['RP1', 'RP2', 'RP3', 'RP4', 'RP5', 'RP6', 'CP'],
                label: '불펜 투수'
            },
            effect: {
                type: 'States',
                states: {...baseStates, s3: 2, s4: 2, s5: 2},
                label: '제구, 구위, 지구력 +2'
            }
        }
    },
    {
        point: 120, 
        left: {
            target: {
                type: 'BatterLineup',
                positions: ['3번', '4번', '5번'],
                label: '중심 타선(3~5번)'
            },
            effect: {
                type: 'States',
                states: baseStatesWithTwo,
                label: '모든 능력치 +2'
            }
        },
        right: {
            target: {
                type: 'Position',
                positions: ['SP1', 'SP2', 'SP3', 'SP4', 'SP5'],
                label: '선발 투수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        }
    },
    {
        point: 125, 
        left: {
            target: {
                type: 'NumberOfStar',
                numberOfStar: 4,
                label: '4성 선수'
            },
            effect: {
                type: 'StatesByPosition',
                statesForBatter: {...baseStates, s2: 2, s3: 2, s4: 2},
                statesForPitcher: {...baseStates, s1: 2, s2: 2, s4: 2},
                label: '타자 : 정확, 선구, 인내 +2 <br>투수 : 구속, 변화, 제구 +2',
            }
        },
        right: {
            target: {
                type: 'NumberOfStar',
                numberOfStar: 5,
                label: '5성 선수'
            },
            effect: {
                type: 'StatesByPosition',
                statesForBatter: {...baseStates, s4: 1},
                statesForPitcher: {...baseStates, s4: 1},
                label: '타자 : 인내 +1<br>투수 : 제구 +1',

            }
        }
    },
    {
        point: 130, 
        left: {
            target: {
                type: 'CardType',
                cardTypes: ['시즌', '라이브', '올스타'],
                label: '시즌&라이브&올스타 선수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        },
        right: {
            target: {
                type: 'CardType',
                cardTypes: ['임팩트', '국가대표', '시그니쳐', '골든글러브'],
                label: '임팩트&국가대표&<br>시그니쳐&골든글러브 선수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        }
    },
    {
        point: 135, 
        left: {
            target: {
                type: 'BatterLineup',
                positions: ['3번', '4번', '5번'],
                label: '중심 타선(3~5번)'
            },
            effect: {
                type: 'States',
                states: {...baseStates, s2: 2, s5: 2, s6: 2},
                label: '정확, 주루, 수비 +2'
            }
        },
        right: {
            target: {
                type: 'Position',
                positions: ['SP1', 'SP2', 'SP3', 'SP4', 'SP5'],
                label: '선발 투수'
            },
            effect: {
                type: 'States',
                states: {...baseStates, s3: 1, s4: 1, s5: 1},
                label: '제구, 구위, 지구력 +1'
            }
        }
    },
    {
        point: 140, 
        left: {
            target: {
                type: 'BatterLineup',
                positions: ['6번', '7번', '8번', '9번'],
                label: '하위 타선(6~9번)'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        },
        right: {
            target: {
                type: 'Position',
                positions: ['RP1', 'RP2', 'RP3', 'RP4', 'RP5', 'RP6', 'CP'],
                label: '불펜 투수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        }
    },
    {
        point: 145, 
        left: {
            target: {
                type: 'BatterLineup',
                positions: ['1번', '2번'],
                label: '상위 타선(1~2번)'
            },
            effect: {
                type: 'States',
                states: {...baseStates, s2: 2, s3: 2, s5: 2},
                label: '정확, 주루, 선구 +2'
            }
        },
        right: {
            target: {
                type: 'Position',
                positions: ['SP1', 'SP2', 'SP3', 'SP4', 'SP5'],
                label: '선발 투수'
            },
            effect: {
                type: 'States',
                states: {...baseStates, s3: 1, s4: 1, s5: 1},
                label: '제구, 구위, 지구력 +1'
            }
        }
    },
    {
        point: 150, 
        left: {
            target: {
                type: 'Team',
                label: '선택 팀 선수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithTwo,
                label: '모든 능력치 +2'
            }
        },
        right: {
            target: {
                type: 'CardType',
                cardTypes: ['임팩트', '국가대표', '시그니쳐', '골든글러브'],
                label: '임팩트&국가대표&<br>시그니쳐&골든글러브 선수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithTwo,
                label: '모든 능력치 +2'
            }
        }
    },
    {
        point: 155, 
        left: {
            target: {
                type: 'BatterLineup',
                positions: ['1번', '2번'],
                label: '상위 타선(1~2번)'
            },
            effect: {
                type: 'States',
                states: {...baseStates, s1: 2, s3: 2, s4: 2},
                label: '파워, 선구, 인내 +2'
            }
        },
        right: {
            target: {
                type: 'Position',
                positions: ['SP1', 'SP2', 'SP3', 'SP4', 'SP5'],
                label: '선발 투수'
            },
            effect: {
                type: 'States',
                states: {...baseStates, s1: 1, s2: 1, s6: 1},
                label: '구속, 변화, 수비 +1'
            }
        }
    },
    {
        point: 160, 
        left: {
            target: {
                type: 'Position',
                positions: batterKeys,
                label: '타자'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        },
        right: {
            target: {
                type: 'Position',
                positions: pitcherKeys,
                label: '투수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        }
    },
    {
        point: 165, 
        left: {
            target: {
                type: 'Position',
                positions: batterKeys,
                label: '타자'
            },
            effect: {
                type: 'States',
                states: {...baseStates, s2: 1, s3: 1, s6: 1},
                label: '정확, 주루, 수비 +1'
            }
        },
        right: {
            target: {
                type: 'Position',
                positions: pitcherKeys,
                label: '투수'
            },
            effect: {
                type: 'States',
                states: {...baseStates, s1: 1, s2: 1, s6: 1},
                label: '구속, 변화, 수비 +1'
            }
        }
    },
    {
        point: 170, 
        left: {
            target: {
                type: 'Team',
                label: '선택 팀 선수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        },
        right: {
            target: {
                type: 'CardType',
                cardTypes: ['임팩트', '국가대표', '시그니쳐', '골든글러브'],
                label: '임팩트&국가대표&<br>시그니쳐&골든글러브 선수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        }
    },
    {
        point: 175, 
        left: {
            target: {
                type: 'Position',
                positions: batterKeys,
                label: '타자'
            },
            effect: {
                type: 'States',
                states: {...baseStates, s1: 1, s3: 1, s4: 1},
                label: '파워, 선구, 인내 +1'
            }
        },
        right: {
            target: {
                type: 'Position',
                positions: pitcherKeys,
                label: '투수'
            },
            effect: {
                type: 'States',
                states: {...baseStates, s3: 1, s4: 1, s5: 1},
                label: '제구, 구위, 지구력 +1'
            }
        }
    },
    {
        point: 180, 
        left: {
            target: {
                type: 'TeamCardType',
                cardTypes: ['라이브','올스타'],
                label: '라이브&올스타 선수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithTwo,
                label: '모든 능력치 +2'
            }
        },
        right: {
            target: {
                type: 'YearPosition',
                positions: positionKeys,
                label: '선택 연도 선수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        },
    },
    {
        point: 185, 
        left: {
            target: {
                type: 'BatterLineup',
                positions: ['1번', '2번'],
                label: '상위 타선(1~2번)'
            },
            effect: {
                type: 'States',
                states: {...baseStates, s1: 2, s5: 2},
                label: '파워, 주루 +2'
            }
        },
        right: {
            target: {
                type: 'YearPosition',
                positions: batterKeys,
                label: '선택 연도 타자'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        },
    },
    {
        point: 190, 
        left: {
            target: {
                type: 'Position',
                positions: ['SP1', 'SP2', 'SP3', 'SP4', 'SP5'],
                label: '선발 투수'
            },
            effect: {
                type: 'States',
                states: {...baseStates, s3: 1, s5: 1},
                label: '구위 +1, 지구력 +1'
            }
        },
        right: {
            target: {
                type: 'YearPosition',
                positions: pitcherKeys,
                label: '선택 연도 투수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        },
    },
    {
        point: 195, 
        left: {
            target: {
                type: 'TeamCardType',
                cardTypes: ['라이브','올스타','국가대표'],
                label: '선택 팀 라이브&<br>올스타&국가대표'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        },
        right: {
            target: {
                type: 'TeamCardType',
                cardTypes: ['시그니쳐'],
                label: '선택 팀 시그니쳐'
            },
            effect: {
                type: 'States',
                states: baseStatesWithOne,
                label: '모든 능력치 +1'
            }
        },
    },
    {
        point: 200, 
        left: {
            target: {
                type: 'TeamPosition',
                positions: batterKeys,
                label: '선택 팀 타자'
            },
            effect: {
                type: 'States',
                states: baseStatesWithTwo,
                label: '모든 능력치 +2'
            }
        },
        right: {
            target: {
                type: 'TeamPosition',
                positions: pitcherKeys,
                label: '선택 팀 투수'
            },
            effect: {
                type: 'States',
                states: baseStatesWithTwo,
                label: '모든 능력치 +2'
            }
        }
    },
]